import { CardContent } from '@mui/material';
import styled from 'styled-components';

export const GridOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const DivHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonLink = styled.button`
  display: flex;
  margin-right: 20px;
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: unset;
  cursor: pointer;
`;

export const CustomCardContent = styled(CardContent)`
  display: flex;
  flex-direction: column;
  width: 330px;
  max-width: 330px;
  padding: 13px 18px 13px 0px !important;
`;
